import request from "@/utils/request";

export default function agentOpenedAVipForWeChat(params) {
    return request({
        url: `/device/memberMonthly/agentOpenedAVipForWeChat`,
        method: 'post',
        params: params
    })
}
